import { EditCalendarOutlined } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { Link } from "react-router-dom";
import {caseInsensitiveSort} from "../common/Utils";

export const columns = (userAccessRole)=>[
	{
		name: 'Enrollment Date/Time',
		selector: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>{`${row.enrollmentDate} ${row.achTime}`}</div>,
        sortable: true,
		center: true,
		minWidth:"200px",
		style: {
			justifyContent: "center",
			textAlign:"center",
			minWidth:"200px",
		},
		sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.enrollmentDate && row.achTime? 
		row.enrollmentDate+row.achTime :""),
	},
	{
		name: 'Payee Name',
		selector: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>
			{(`${row?.payeeFirstName ?? ""} ${row?.payeeLastName ?? ""}`.trim().toUpperCase() || "-")}
			</div>,
        sortable: true,
		minWidth:"220px",
		center: true,
		style: {
			justifyContent: "center",
			textAlign:"center",
			minWidth:"220px",
		},
		sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.payeeFirstName? row.payeeFirstName : row.payeeLastName ? row.payeeLastName : ""),
	},
	{
		name: 'Representative Payee',
		selector: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>{row.representativePayee}</div>,
        sortable: true,
		wrap: true,
		center: true,
		minWidth:"220px",
		style: {
			justifyContent: "center",
			textAlign:"center",
			minWidth:"220px",
		},
		sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.representativePayee? row.representativePayee :""),
	},
	{
		name: 'Updated By',
		selector: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>{row.updatedBy}</div>,
        sortable: true,
		wrap: true,
		minWidth:"250px",
		center: true,
		style: {
			justifyContent: "center",
			textAlign:"center",
			minWidth:"250px",
		},
		sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.updatedBy? row.updatedBy :""),
	},
	{
		name: 'Updated Date',
		selector: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>{row.updatedDate}</div>,
        sortable: true,
		wrap: true,
		center: true,
		style: {
			justifyContent: "center",
			textAlign:"center",
			minWidth:"180px",
		},
		sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.updatedDate? row.updatedDate :""),
		minWidth:"180px"
	},
	{
		name: 'Edit',
		button: true,
		center: true,
		minWidth:"120px",
		omit: userAccessRole === "" || userAccessRole === "Read" || userAccessRole === undefined || userAccessRole === null,
		style: {
			justifyContent: "center",
			textAlign:"center",
			minWidth:"120px",
		},
		cell: row =>
			<div style={{overflow:"hidden",textOverflow:"ellipsis"}}> 
			<Link to="/enrollment/edit" state={row}><IconButton  row={row} data-tag="allowRowEvents" data-action="edit">
			<EditCalendarOutlined sx={{ color:'#002d82'}} data-tag="allowRowEvents" row={row} data-action="edit"/>
			</IconButton></Link>
			</div>
	} 
];

export const exportDirectDepositColumns=[
	{
		header: 'Enrollment Date',
		key: 'enrollmentDate'
	},
	{
		header: 'Enrollment Time',
		key: 'achTime'
	},
	{
		header: 'Payee First Name',
		key: 'payeeFirstName'
	},
	{
		header: 'Payee Last Name',
		key: 'payeeLastName'
	},
	{
		header: 'Benefit Type',
		key: 'benefitType'
	},
	{
		header: 'Representative Payee',
		key: 'representativePayee'
	},
	{
		header: 'Created By',
		key: 'userName',
	},
	{
		header: 'Created Date',
		key: 'achDate',
	},
	{
		header: 'Updated By',
		key: 'updatedBy',
	},
	{
		header: 'Updated Date',
		key: 'updatedDate',
	},
]